import { useEffect, useState } from "react";
import classes from "./Scale.module.css";
import useTheme from "../../../../common/hooks/useTheme";

type Props = {
  id: number;
  dispatchAnswer: any;
  label: string;
  answer: number;
  min: number;
  max: number;
};

const Scale = ({ id, dispatchAnswer, label, answer, min, max }: Props) => {
  const theme = useTheme();
  const [num, setNum] = useState(+answer);
  const [upStyle, setUpStyle] = useState("inactive");
  const [downStyle, setDownStyle] = useState("inactive");
  const [focusInput, setFocusInput] = useState(false);

  useEffect(() => {
    dispatchAnswer(num, id);
  }, [num, id]);

  const increment = () => {
    if (answer >= max) {
      setUpStyle("disable");
      return;
    } else {
      setUpStyle("active");
    }
    setFocusInput(true);
    setUpStyle("hover");
    setDownStyle("active");
    setTimeout(() => {
      setUpStyle("active");
      setFocusInput(false);
    }, 100);

    setNum(num < max ? num + 1 : +num);
  };

  const decrement = () => {
    if (answer <= min) {
      setDownStyle("disable");
      return;
    } else {
      setDownStyle("active");
    }
    setFocusInput(true);
    setDownStyle("hover");
    setUpStyle("active");
    setTimeout(() => {
      setDownStyle("active");
      setFocusInput(false);
    }, 100);

    setNum(num >= min ? num - 1 : num);
  };

  const handleChangeInput = (e: any) => {
    e.preventDefault();

    let inputValue = +e.target.value;

    if (inputValue <= min) {
      setDownStyle("inactive");
      setUpStyle("active");
      setNum(inputValue);
    } else if (inputValue > max) {
      setDownStyle("active");
      setUpStyle("inactive");
    } else {
      setDownStyle("active");
      setUpStyle("active");
      setNum(inputValue);
    }
  };
  const getArrowStyle = (arrow: string) => {
    switch (arrow) {
      case "inactive":
        return theme.colors_ds.NEUTRAL_ICON_WEAK;

      case "active":
        return theme.colors_ds.PRIMARY_ICON_MAIN;

      case "hover":
        return theme.colorTokens.P[90];

      case "disable":
        return theme.colors_ds.NEUTRAL_TEXT_INACTIVE;
    }
  };

  return (
    <div className={classes.container}>
      <svg
        width="16"
        height="9"
        viewBox="0 0 16 9"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={classes.icon}
        onClick={increment}
      >
        <path d="M8 0L0 9H16L8 0Z" fill={getArrowStyle(upStyle)} />
      </svg>

      <label
        className={classes.text}
        style={{ color: theme.colors_ds.NEUTRAL_TEXT_DEFAULT }}
      >
        <input
          type="number"
          value={answer ? answer : 0}
          onChange={handleChangeInput}
          className={`${classes.input} ${answer !== 0 && classes.inputOk}`}
          style={{
            borderWidth: focusInput ? "2px" : "1px",
            borderColor:
              answer !== 0
                ? theme.colors_ds.PRIMARY_ICON_MAIN
                : theme.colors_ds.NEUTRAL_BORDER_WEAK,
            color:
              answer !== 0
                ? theme.colors_ds.NEUTRAL_TEXT_STRONG
                : theme.colors_ds.NEUTRAL_TEXT_INACTIVE,
            caretColor: theme.colors_ds.PRIMARY_ICON_MAIN,
          }}
        />
        {label}
      </label>
      <svg
        width="16"
        height="9"
        viewBox="0 0 16 9"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={classes.icon}
        onClick={decrement}
        style={{ transform: "matrix(1, 0, 0, -1, 0, 0)" }}
      >
        <path d="M8 0L0 9H16L8 0Z" fill={getArrowStyle(downStyle)} />
      </svg>
    </div>
  );
};

export default Scale;
